var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.users, function(user, index) {
      return _c(
        "fieldset",
        { key: user.id, staticClass: "custom-fieldset" },
        [
          _c("legend", [
            _vm._v(_vm._s(_vm.$t("global.passenger")) + " " + _vm._s(index + 1))
          ]),
          _c("admin-passenger-data-preview", { attrs: { user: user } })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }